import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import DiaryLogGroup from "./../../containers/Diaries/Logs/logGroup";
import ListingComponent from "../ListingComponent";
import { getDiaryLogs } from "../../containers/Diaries/actions";

// Helpers Func
const getLastTodoId = (todoUpdates = []) =>
    todoUpdates.length ? todoUpdates[todoUpdates.length - 1].Id : 0;

const mapLogItems = (logs) =>
    logs.map(item => {
        const [date, time] = (item.NonFormatedUpdatedDate ?? '').split('at');
        return {
            id:   getLastTodoId(item.TodoUpdates),
            date,
            time,
            data: item,
        };
    });

const groupByDate = (items) =>
    items.reduce((acc, item) => {
        if (!acc[item.date]) acc[item.date] = [];
        acc[item.date].push(item);
        return acc;
    }, {});

const NOOP = () => false; 

const Logs = ({ id }) => {
    const dispatch = useDispatch();

    const { diaryLogs, isRightLoading } = useSelector(state => ({
        diaryLogs:      state.diaries.view.diaryInfo.logs,
        isRightLoading: state.diaries.listing.isRightLoading,
    }), shallowEqual);

    useEffect(() => {
        dispatch(getDiaryLogs({ id }));
    }, []);

    const todoLogs = diaryLogs?.todoLogs;
    const hasLogs  = todoLogs?.length > 0;

    if (!hasLogs) {
        return (
            <div className="logMainContainer detailMainContainer diaryModalGroup">
                {!isRightLoading && <div className="noDataFound">No Data Found</div>}
            </div>
        );
    }

    const grouped = groupByDate(mapLogItems(todoLogs));
    const listProps = {
        data:            Object.keys(grouped).map(key => ({ key, data: grouped[key] })),
        cellTemplate:    DiaryLogGroup,
        onScrollHandler: NOOP,
        onItemClick:     NOOP,
        type:            "ul",
        classname:       'diaryGroupScroll',
        selectedId:      '',
    };

    return (
        <div className="logMainContainer detailMainContainer diaryModalGroup">
            <ListingComponent {...listProps} />
        </div>
    );
};

export default Logs;